import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import { connect } from 'react-redux'
import ItemSummary from '../components/ItemSummary'
import { withErrorBoundary } from '../errors/ErrorBoundary'
import { landCoverMetadata } from '../config/landCover'

const styles = theme => ({
  container: {
    position: 'absolute',
    top: '10px',
    right: '100px'
  }
})

const demos = {
  146463: {
    'well name': 'Demo 1',
    'spud date': '2010-08-09',
    'licensee': 'Acme',
    'license #': '0081929'
  },
  146190: {
    'well name': 'Demo 2',
    'spud date': '2012-03-17',
    'licensee': 'Acme',
    'license #': '2041449'
  },
  147247: {
    'well name': 'Demo 3',
    'spud date': '2009-04-12',
    'licensee': 'Acme',
    'license #': '4583581'
  },
  147331: {
    'well name': 'Demo water',
    'spud date': '2010-08-09',
    'licensee': 'Acme',
    'license #': '0111384'
  },
  147412: {
    'well name': 'Demo vegetation',
    'spud date': '2003-09-22',
    'licensee': 'Acme',
    'license #': '2581449'
  }
}

class ItemSummaryFloatContainer extends PureComponent {
  render () {
    const { classes, data } = this.props
    // console.log('summary container')
    // console.log(data)
    if (!data) {
      return null
    }

    const whitelist = ['land_cover', 'ndvi', 'rank', 'wellsite_f']
    let items = Object.keys(data)
          .filter(key => whitelist.includes(key))
          .map(key => {
            const title = key
            let value
            let label
            if (key === 'wellsite_f') {
              value = data[key]
              label = 'wellsite id'
            } else if (key === 'land_cover') {
              value = landCoverMetadata.find(item => item.value === data[key]).label
              label = 'land cover'
            } else if (key === 'rank') {
              value = data[key].toFixed(2)
              label = '\u03C3'
            } else if (key === 'ndvi') {
              value = (data[key] / 1000).toFixed(2)
              label = 'ndvi'
            } else {
              value = data[key]
              label = key
            }
            return (
                <ItemSummary title={label} value={value} key={key}/>
            )
          })
    const { wellsite_f } = data

    if (wellsite_f && Object.keys(demos).includes(wellsite_f.toString())) {
      const meta_data = demos[wellsite_f]
      console.log(meta_data)
      window.meta_data = meta_data
      let meta_items = Object.keys(meta_data)
            .map(key => <ItemSummary title={key} value={meta_data[key]} key={key}/>)
      items = items.concat(<ItemSummary title={'label'} value={'value'} key={'key'}/>)
      items = meta_items.concat(items)
    }
    return (
      <div className={classes.container}>
        <Card>
          {items}
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    // data: state.data.LeakDetection
    data: state.data[ownProps.id]
  }
}

export default connect(mapStateToProps, null)(withStyles(styles)(ItemSummaryFloatContainer))



// WEBPACK FOOTER //
// ./src/containers/ItemSummaryFloatContainer.js